import { useEffect } from 'react'
import { Form, Input, Button, Typography, message } from 'antd'
import { UserOutlined, LockOutlined } from '@ant-design/icons'
import { useNavigate } from 'react-router-dom'
import { useAuthStore } from '@/stores/auth'
import type { LoginPayload } from '@/types'
import '../../styles/aurora-page.css'

const { Title, Text } = Typography

export default function Login() {
  const navigate = useNavigate()
  const { login, loading, token } = useAuthStore()

  useEffect(() => {
    if (token) navigate('/dashboard')
  }, [token, navigate])

  const onFinish = async (values: LoginPayload) => {
    try {
      await login(values)
      message.success('登录成功')
      navigate('/dashboard')
    } catch (e) {
      console.error('[Login] 登录失败:', e)
    }
  }

  return (
    <div className="login-bg aurora-login" style={{ position: 'relative' }}>
      <div className="login-card aurora-login-card">
        {/* Logo 与标题 */}
        <div style={{ textAlign: 'center', marginBottom: 36 }}>
          <img
            src="/logo.png"
            alt="AuroraTest"
            style={{
              width: 56,
              height: 56,
              margin: '0 auto 16px',
              display: 'block',
              borderRadius: 16,
              boxShadow: '0 8px 24px rgba(90, 141, 110, 0.28)',
            }}
          />
          <Title level={3} style={{ marginTop: 0, marginBottom: 4, fontWeight: 700, letterSpacing: '-0.02em' }}>
            极光测试笔记
          </Title>
          <Text type="secondary" style={{ fontSize: 13, color: 'var(--au-slate-muted)' }}>
            AuroraTest
          </Text>
        </div>

        {/* 登录表单 */}
        <Form
          name="login"
          onFinish={onFinish}
          autoComplete="off"
          size="large"
          initialValues={{}}
        >
          <Form.Item
            name="username"
            rules={[{ required: true, message: '请输入用户名' }]}
          >
            <Input
              prefix={<UserOutlined style={{ color: 'var(--au-text-faint)' }} />}
              placeholder="用户名或邮箱"
              autoComplete="username"
            />
          </Form.Item>

          <Form.Item
            name="password"
            rules={[{ required: true, message: '请输入密码' }]}
          >
            <Input.Password
              prefix={<LockOutlined style={{ color: 'var(--au-text-faint)' }} />}
              placeholder="密码"
              autoComplete="current-password"
            />
          </Form.Item>

          <Form.Item style={{ marginBottom: 16 }}>
            <Button
              type="primary"
              htmlType="submit"
              block
              loading={loading}
              style={{ height: 44, fontSize: 15, fontWeight: 600 }}
            >
              登 录
            </Button>
          </Form.Item>
        </Form>

        {/* 分隔线 */}
        <div
          style={{
            display: 'flex',
            alignItems: 'center',
            gap: 12,
            margin: '8px 0 20px',
          }}
        >
          <div style={{ flex: 1, height: 1, background: 'var(--au-border)' }} />
          <Text type="secondary" style={{ fontSize: 12, color: 'var(--au-text-faint)' }}>
            默认账号
          </Text>
          <div style={{ flex: 1, height: 1, background: 'var(--au-border)' }} />
        </div>

        {/* 默认账号提示 */}
        <div
          style={{
            background: 'var(--au-primary-50)',
            border: '1px solid var(--au-primary-100)',
            borderRadius: 12,
            padding: '14px 16px',
            fontSize: 12,
            color: 'var(--au-slate-muted)',
            lineHeight: 1.8,
          }}
        >

          <div style={{ display: 'flex', justifyContent: 'space-between' }}>
            <span>测试</span>
            <span style={{ fontFamily: 'monospace', color: 'var(--au-primary)', fontWeight: 600 }}>tester / tester123</span>
          </div>
        </div>

      </div>

      {/* 页面底部：版本与备案号（不随登录卡片，固定于页面最下方居中） */}
      <div
        style={{
          position: 'absolute',
          bottom: 16,
          left: 0,
          right: 0,
          textAlign: 'center',
          fontSize: 12,
          lineHeight: 1.8,
          color: 'var(--au-text-faint)',
        }}
      >
        <div>
          v1.0.1 © 极光测试笔记 ·{' '}
          <a href="https://beian.miit.gov.cn" target="_blank" rel="noreferrer" style={{ color: 'inherit' }}>
            湘ICP备2026038728号-2
          </a>{' '}
          ·{' '}
          {/* 公安备案官方要求的联网备案代码（beian.mps.gov.cn 生成的 href 与文案原样保留） */}
          <a
            href="https://beian.mps.gov.cn/#/query/webSearch?code=43011202001430"
            target="_blank"
            rel="noreferrer"
            style={{ color: 'inherit' }}
          >
            <img
              src="/beian-gongan.png"
              alt="公安备案徽标"
              style={{ width: 14, height: 14, verticalAlign: '-2px', marginRight: 3 }}
            />
            湘公网安备43011202001430号
          </a>
        </div>
      </div>
    </div>
  )
}
